import React from 'react';
import './App.css';
import './styles/photography.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Services from './pages/Services';
import Preise from './pages/Preise';
import Contact from './pages/Contact';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import SubmitReview from './pages/SubmitReview';
import AdminLogin from './pages/AdminLogin';
import AdminUpload from './pages/AdminUpload';
import AdminSettings from './pages/AdminSettings';
import AdminCategories from './pages/AdminCategories';
import AdminServices from './pages/AdminServices';
import AdminTestimonials from './pages/AdminTestimonials';
import AdminMessages from './pages/AdminMessages';
import AdminAccount from './pages/AdminAccount';
import AdminPreise from './pages/AdminPreise';
import CookieBanner from './components/CookieBanner';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin routes without Header/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/upload" element={<AdminUpload />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/categories" element={<AdminCategories />} />
            <Route path="/admin/services" element={<AdminServices />} />
            <Route path="/admin/testimonials" element={<AdminTestimonials />} />
            <Route path="/admin/messages" element={<AdminMessages />} />
            <Route path="/admin/account" element={<AdminAccount />} />
            <Route path="/admin/preise" element={<AdminPreise />} />
            
            {/* Public routes with Header/Footer */}
            <Route path="/*" element={
              <>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/galerie" element={<Gallery />} />
                  <Route path="/ueber-mich" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/preise" element={<Preise />} />
                  <Route path="/kontakt" element={<Contact />} />
                  <Route path="/impressum" element={<Impressum />} />
                  <Route path="/datenschutz" element={<Datenschutz />} />
                  <Route path="/bewertung-abgeben" element={<SubmitReview />} />
                </Routes>
                <Footer />
                <CookieBanner />
              </>
            } />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
